import { useEffect, useState } from 'react';
import { getStaticFilePath } from '../utils';

export interface IBlurryLoadingImageProps {
  preview: string;
  image: string;
  height: number | string;
  width: number | string;
  alt: string;
}

const BlurryLoadingImage = ({
  preview,
  image,
  height,
  width,
  alt
}: IBlurryLoadingImageProps) => {
  const [src, setSrc] = useState(preview);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    setSrc(preview);
    const img = new Image();
    img.src = getStaticFilePath(image);
    img.onload = () => {
      setSrc(image);
      setLoaded(true);
    };
  }, [preview, image]);

  return (
    <img
      alt={alt}
      src={loaded ? getStaticFilePath(src) : preview}
      data-src={getStaticFilePath(src)}
      height={height}
      width={width}
      style={{
        objectFit: 'cover',
        objectPosition: 'left',
        filter: loaded ? 'none' : 'blur(2px)',
        transition: 'filter 0.5s ease-out'
      }}
    />
  );
};

export default BlurryLoadingImage;
